// extracted by mini-css-extract-plugin
module.exports = {"BookingEquipmentListTabWidth":"BookingEquipmentListTab_BookingEquipmentListTabWidth__36uVk","activeButton":"BookingEquipmentListTab_activeButton__3MyzQ"};